import { FilterButton } from '@finder/shared/components/filters/classes/filter-button.class';

export class DrawerFilterButton extends FilterButton {
    defaultLabel: string;

    private displayed = false;

    constructor(
        id: string,
        label: string,
        icon: string,
        ariaLabel: string,
        facets: Array<any>,
        public displayedDrawerLabel
    ) {
        super(id, label, icon, ariaLabel, facets);
        this.defaultLabel = label;
    }

    get displayedDrawer() {
        return this.displayed;
    }

    set displayedDrawer(value: boolean) {
        this.displayed = value;
        this.label = this.displayed ? this.displayedDrawerLabel : this.defaultLabel;
        this.setSelectedState();
    }

    toggleDisplayedState() {
        this.displayedDrawer = this.displayed ? false : true;
    }

    setSelectedState() {
        this.selected = this.facets.some(f => f.value) || this.displayedDrawer;
    }
}
